import http from "../js/axios";
import { addAuthParams } from "../js/common";
class HomeSerive {
  getProviders(params) {
    return http.get("/Admin/Services/Recharge.asmx/GetService_List", {
      params,
    });
  }
  getStateList() {
    return http.get("/Admin/Services/Recharge.asmx/State_List");
  }
  calculateCharge(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Recharge.asmx/Calculate_Recharge_Charge", {
      params,
    });
  }
  getRechargeDetails(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Recharge.asmx/Recharge_Detail", {
      params,
    });
  }
  doRecharge(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Recharge.asmx/Do_Recharge", {
      params,
    });
  }
  complaint(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Recharge.asmx/Complain_Register", {
      params,
    });
  }
}
export default new HomeSerive();
